<script>
    import { onMount } from 'svelte';
    import { firestore } from "../firebase/firebase.js";
    // import moment from 'moment';

    export let deckId;

    var cards = [];
    var loading = false;
    var removeCardLoading = false;
    var currentCardId = '';
    var cardsBindings = {};

    onMount(async () => {
        try {
            if (deckId != 'new') {
                loading = true;
                await fetchCards()
                loading = false;
            }
        } catch (error) {

        }
    });

    async function fetchCards() {
        try {
            var today = new Date();
            var res = await firestore.collection('decks').doc(deckId).collection('cards').orderBy('created_at').get();
            cards = res.docs
            if (cards && cards && cards.length != 0) {
                for (let i = 0; i < cards.length; i++) {
                    const card = cards[i];
                    cardsBindings[card.id] = card.data()['title'];
                }
            }
        } catch (error) {

        }
    }

    async function newCard() {
        if (deckId != 'new') {
            try {
                await firestore.collection('decks').doc(deckId).collection('cards').add({
                    title: '',
                    is_available: true,
                    created_at: new Date()
                })
                fetchCards()
            } catch (error) {

            }
        }
    }

    async function updateCard(e) {
        if (deckId != 'new') {
            try {
                await firestore.collection('decks').doc(deckId).collection('cards').doc(e.target.id).set({
                    title: e.target.value,
                }, { merge: true });
            } catch (error) {

            }
        }
    }

    async function removeCard(id) {
        if (deckId != 'new') {
            if (!removeCardLoading) {
                try {
                    currentCardId = id
                    removeCardLoading = true;
                    await firestore.collection('decks').doc(deckId).collection('cards').doc(id).delete();
                    removeCardLoading = false;
                    currentCardId = id = '';
                    fetchCards()
                } catch (error) {
                    currentCardId = id = '';
                    removeCardLoading = false;
                }
            }
        }
    }
</script>

<div id="card_list">
    <div class="mt-1">
        <div class="d-flex justify-content-between align-items-center w-100 mb-3">
            <h2>Cards</h2>
            <button on:click="{newCard}" type="button" class="btn btn-info">New</button>
        </div>
        <div class="row pb-5">
            <ul class="list-group w-100" style="margin: 0 15px ;">
                {#if loading}
                    <div style="width: 100%;" class="mt-5">
                        <div class="d-flex justify-content-center">
                            <div class="spinner-grow text-secondary" role="status">
                            <span class="sr-only">Loading...</span>
                            </div>
                        </div>
                    </div>
                {:else}
                    {#if cards && cards.length != 0}
                        <div class="card-list grid_container">
                            {#each cards as card}
                                <div  style="position: relative; z-index: 1; color: #495057; text-decoration: none; background-color: #f8f9fa;" class:grid_item="{true}" class:dimmed="{removeCardLoading && card.id == currentCardId}" class:d-flex="{true}" class:justify-content-between="{true}" class:align-items-center="{true}" class:list-group-item="{true}" class:list-group-item-action="{true}">
                                    <input style="border: 0 !important" name="{card.id}" id={card.id} on:input={updateCard} bind:value="{cardsBindings[card.id]}" type="text" class="card-field form-control"  aria-describedby="inputGroup-sizing-sm">
                                    <div style="padding-left: 5px;" class="btn-group remove_btn_wrapper" role="group" aria-label="Basic example">
                                        <button on:click="{removeCard(card.id)}" type="button" class="btn btn-danger btn-sm remove_btn"><i class="fa fa-times"></i></button>
                                    </div>
                                </div>
                            {/each}
                        </div>
                    {:else}
                        <span style="text-align: center; padding: 30px;">No cards</span>
                    {/if}
                {/if}
            </ul>
        </div>
    </div>
</div>

<style>
    .dimmed {
        opacity: 0.5;
        cursor: wait;
    }

    .card-field:focus {
        border-color: rgb(99, 169, 240, 0.8) !important;
        box-shadow: 0 1px 1px rgba(0, 0, 0, 0.075) inset, 0 0 2px rgb(99, 169, 240, 0.6) !important;
        outline: 0 none !important;
    }

    .grid_container {
        display: grid;
        justify-content: start;
        align-content: start;
        grid-auto-flow: row;
        grid-template-columns: repeat(3, 33.333333%);
    }

    @media (max-width: 991.98px) { 
        .grid_container{
                grid-template-columns: repeat(2, 50%) !important;
            }
    }

     .list-group-item:last-child{
        border-radius: 0 !important;
    }

     .list-group-item:first-child{
        border-radius: 0 !important;
    }

    .remove_btn_wrapper{
        display: none;
        position: absolute;
        right: 0 !important;
        top: 0 !important;
    }

    .grid_item:hover .remove_btn_wrapper{
        display: block;
    }

    .remove_btn{
        border-radius: 50%;
        width: 15px;
        font-size: 8px;
        display: flex;
        justify-content: center;
        align-items: center;
    }

</style>